import { postRequest } from '../../../shared/utils';

export async function getTbloptBooleanIdService({ value, screenGridId }) {
  const body = {
    columns: ['id'],
    screenGridId,
    schema: 'npi',
    table: 'tblopt_boolean_value',
    key: 'display_name',
    value: value,
  };

  const { data, errors } = await postRequest(`/api/records`, body);

  if (errors) {
    return { errors };
  }

  return data;
}
